import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Asset, GetStoreRevisionInfoQuery } from '../../../common/generated-types';
import { take } from 'rxjs/operators';
import { ContactFormData, TitleInfo } from '../../../common/interfaces';
import { StateService } from '../../providers/state/state.service';

interface ContactMessage {
    name: string;
    phone: string;
    email: string;
    message: string;
};

@Component({
    selector: 'vsf-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactFormComponent implements OnInit {
    @Input() isMobile: boolean | null;
    @Input() contactForm: ContactFormData;
    @Input() linePadding: string;
    @Input() titleInfo: TitleInfo | null = null;

    contactEmail: string;
    contactFormType: string;
    featuredAsset: Asset;
    maxMessageLength = 600;

    contact: ContactMessage = {
        name: '',
        phone: '',
        email: '',
        message: ''
    };

    constructor(private stateService: StateService) {}

    ngOnInit(): void {
        if(this.contactForm) {
            this.contactEmail = this.contactForm.email || '';
            this.contactFormType = this.contactForm.contactFormType || this.contactFormType;
            this.featuredAsset = this.contactForm.featuredAsset || this.featuredAsset;
            if(!this.contactEmail){
                this.stateService.select((state:any) => state.storeInfo).pipe(take(1)).subscribe((storeInfo: GetStoreRevisionInfoQuery['storeInfo']) => {
                    this.contactEmail = storeInfo?.supportEmail || storeInfo?.sellerChannel?.customFields?.notificationEmail || '';
                });
            }
        }
    }

    onMessageInput(message: string): void {
        this.contact.message = message;
    }

    onSubmit(): void {
        const mailtoLink = `mailto:${this.contactEmail}?subject=Contact%20Form%20Submission&body=Name:%20${encodeURIComponent(this.contact.name)}%0A
        Phone:%20${encodeURIComponent(this.contact.phone)}%0A
        Email:%20${encodeURIComponent(this.contact.email)}%0A
        Message:%20${encodeURIComponent(this.contact.message)}`;

        if(window) {
            window.location.href = mailtoLink;
        }
    }
}
